import { PaletteOptions, Shadows, SimplePaletteColorOptions, ThemeOptions, TypeAction } from "@mui/material";

const darkShadows: Shadows = [
    "none",
    "0px 2px 1px -1px rgba(80,80,80,0.4),0px 1px 1px 0px rgba(80,80,80,0.4),0px 1px 3px 0px rgba(80,80,80,0.4)",
    "0px 3px 1px -2px rgba(80,80,80,0.4),0px 2px 2px 0px rgba(80,80,80,0.4),0px 1px 5px 0px rgba(80,80,80,0.4)",
    "0px 3px 3px -2px rgba(80,80,80,0.4),0px 3px 4px 0px rgba(80,80,80,0.4),0px 1px 8px 0px rgba(80,80,80,0.4)",
    "0px 2px 4px -1px rgba(80,80,80,0.4),0px 4px 5px 0px rgba(80,80,80,0.4),0px 1px 10px 0px rgba(80,80,80,0.4)",
    "0px 3px 5px -1px rgba(80,80,80,0.4),0px 5px 8px 0px rgba(80,80,80,0.4),0px 1px 14px 0px rgba(80,80,80,0.4)",
    "0px 3px 5px -1px rgba(80,80,80,0.4),0px 6px 10px 0px rgba(80,80,80,0.4),0px 1px 18px 0px rgba(80,80,80,0.4)",
    "0px 4px 5px -2px rgba(80,80,80,0.4),0px 7px 10px 1px rgba(80,80,80,0.4),0px 2px 16px 1px rgba(80,80,80,0.4)",
    "0px 5px 5px -3px rgba(80,80,80,0.4),0px 8px 10px 1px rgba(80,80,80,0.4),0px 3px 14px 2px rgba(80,80,80,0.4)",
    "0px 5px 6px -3px rgba(80,80,80,0.4),0px 9px 12px 1px rgba(80,80,80,0.4),0px 3px 16px 2px rgba(80,80,80,0.4)",
    "0px 6px 6px -3px rgba(80,80,80,0.4),0px 10px 14px 1px rgba(80,80,80,0.4),0px 4px 18px 3px rgba(80,80,80,0.4)",
    "0px 6px 7px -4px rgba(80,80,80,0.4),0px 11px 15px 1px rgba(80,80,80,0.4),0px 4px 20px 3px rgba(80,80,80,0.4)",
    "0px 7px 8px -4px rgba(80,80,80,0.4),0px 12px 17px 2px rgba(80,80,80,0.4),0px 5px 22px 4px rgba(80,80,80,0.4)",
    "0px 7px 8px -4px rgba(80,80,80,0.4),0px 13px 19px 2px rgba(80,80,80,0.4),0px 5px 24px 4px rgba(80,80,80,0.4)",
    "0px 7px 9px -4px rgba(80,80,80,0.4),0px 14px 21px 2px rgba(80,80,80,0.4),0px 5px 26px 4px rgba(80,80,80,0.4)",
    "0px 8px 9px -5px rgba(80,80,80,0.4),0px 15px 22px 2px rgba(80,80,80,0.4),0px 6px 28px 5px rgba(80,80,80,0.4)",
    "0px 8px 10px -5px rgba(80,80,80,0.4),0px 16px 24px 2px rgba(80,80,80,0.4),0px 6px 30px 5px rgba(80,80,80,0.4)",
    "0px 8px 11px -5px rgba(80,80,80,0.4),0px 17px 26px 2px rgba(80,80,80,0.4),0px 6px 32px 5px rgba(80,80,80,0.4)",
    "0px 9px 11px -5px rgba(80,80,80,0.4),0px 18px 28px 2px rgba(80,80,80,0.4),0px 7px 34px 6px rgba(80,80,80,0.4)",
    "0px 9px 12px -6px rgba(80,80,80,0.4),0px 19px 29px 2px rgba(80,80,80,0.4),0px 7px 36px 6px rgba(80,80,80,0.4)",
    "0px 10px 13px -6px rgba(80,80,80,0.4),0px 20px 31px 3px rgba(80,80,80,0.4),0px 8px 38px 7px rgba(80,80,80,0.4)",
    "0px 10px 13px -6px rgba(80,80,80,0.4),0px 21px 33px 3px rgba(80,80,80,0.4),0px 8px 40px 7px rgba(80,80,80,0.4)",
    "0px 10px 14px -6px rgba(80,80,80,0.4),0px 22px 35px 3px rgba(80,80,80,0.4),0px 8px 42px 7px rgba(80,80,80,0.4)",
    "0px 11px 14px -7px rgba(80,80,80,0.4),0px 23px 36px 3px rgba(80,80,80,0.4),0px 9px 44px 8px rgba(80,80,80,0.4)",
    "0px 11px 15px -7px rgba(80,80,80,0.4),0px 24px 38px 3px rgba(80,80,80,0.4),0px 9px 46px 8px rgba(80,80,80,0.4)"
];

const darkAction: Partial<TypeAction> = {
    disabled: "#828282",
    disabledBackground: "#323232",
};

const DEFAULT_DARK_THEME: ThemeOptions = {
    palette: {
        primary: { main: "#323232", contrastText: "#e2e2e2", },
        secondary: { main: "#424242", contrastText: "#e2e2e2", },
        background: { paper: "#222222", default: "#121212" },
        text: { primary: "#e2e2e2", secondary: "#e2e2e2", },
        action: darkAction,
    },
    shadows: darkShadows,
};

const THEMES: Record<string, ThemeOptions> = {
    ["mui-default"]: {
        palette: {
            secondary: {
                main: "#dc004e",
            },
        },
    },
    ["mui-dark"]: {
        palette: {
            mode: "dark",
            secondary: {
                main: "#dc004e",
            },
        },
    },
    ["dark"]: DEFAULT_DARK_THEME,
    ["blue"]: {
        palette: {
            primary: { main: "#005b96", },
            secondary: { main: "#067ab8", },
        },
    },
    ["blue-red"]: {
        palette: {
            primary: { main: "#005b96", },
            secondary: { main: "#CF0101", },
        },
    },
    ["purple-one"]: {
        palette: {
            primary: { main: "#70008b", contrastText: "#ffffff", },
            secondary: { main: "#7c4d86", contrastText: "#ffffff",},
            background: { paper: "#fff7fb", default: "#fff7fb" },
            text: { primary: "#70008b", secondary: "#7c4d86" },
            info: { main: "#005497", contrastText: "#ffffff" },
            error: { main: "#f44336", contrastText: "#ffffff" },
            success: { main: "#4caf50", contrastText: "#ffffff" },
            warning: { main: "#ffc107", contrastText: "#000000"},
            
        } as PaletteOptions,
    },
    ["purple-two"]: {
        palette: {
            primary: { main: "#30003d", contrastText: "#ffffff", },
            secondary: { main: "#735378", contrastText: "#ffffff",},
            background: { paper: "#f7eaf3", default: "#f7eaf3" },
            text: { primary: "#30003d", secondary: "#735378" },
            info: { main: "#003561", contrastText: "#a6d7ff" },
            error: { main: "#9a0a00", contrastText: "#ffd3d3" },
            success: { main: "#006005", contrastText: "#d3ffd9" },
            warning: { main: "#755A00", contrastText: "#FFE48A"},
            
        } as PaletteOptions,
    },
  };

THEMES["dark-blue-red"] = JSON.parse(JSON.stringify(DEFAULT_DARK_THEME));
if (THEMES["dark-blue-red"].palette) {
    (THEMES["dark-blue-red"].palette.primary as SimplePaletteColorOptions).main = "#004573";
    (THEMES["dark-blue-red"].palette.secondary as SimplePaletteColorOptions).main = "#9c0202";
}

THEMES["dark-blue"] = JSON.parse(JSON.stringify(DEFAULT_DARK_THEME));
if (THEMES["dark-blue"].palette) {
    (THEMES["dark-blue"].palette.primary as SimplePaletteColorOptions).main = "#003F69";
    (THEMES["dark-blue"].palette.secondary as SimplePaletteColorOptions).main = "#005b96";
}

export { THEMES };